import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Alert,
  Paper,
  MenuItem,
} from "@mui/material";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, Timestamp, addDoc, collection, updateDoc } from "firebase/firestore";
import Swal from 'sweetalert2';

export default function RegisterPage() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });

  const [name, setName] = useState("");
  const [propName, setpropName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const handleRegister = async () => {
    if (!name || !propName || !email || !password || !confirm) {
      return setMsg("Please fill all fields.");
    }

    if (password !== confirm) {
      return setMsg("Passwords do not match.");
    }

    setLoading(true);
    setMsg("");

    try {
      // 1️⃣ Create Firebase Auth user
      const user = await createUserWithEmailAndPassword(auth, email, password);
      const uid = user.user.uid;


      // 3️⃣ Create user record in authroles including propertyId
      await setDoc(doc(db, "users", uid), {
        email: email,
        mobile: "",
        name: name,
        status: "Active",
        password: password,
        uid: uid,
        role: "Hotelowner",
        createdTime: Timestamp.now(),
      });
      Toast.fire({ icon: "success", title: 'User Registered Successfully!!' });
      window.location.href = "/home";
    } catch (err) {
      setMsg(err.message);
    }

    setLoading(false);
  };

  return (
    <Box bgcolor="#f7f9fb" minHeight="100vh">
      {/* GRADIENT TOP BAR */}
      <Box
        sx={{
          height: 6,
          background:
            "linear-gradient(to right, #1e9bff, #7d55ff, #ff4c8b, #ff7b54, #ffbf00)",
        }}
      />

      {/* ========================= HEADER ========================= */}
      <Box
        sx={{
          height: 80,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #e4e7eb",
          px: 4,
          background: "#ffffff",
        }}
      >
        {/* Logo Section */}
        <Box display="flex" alignItems="center" gap={2}>

          <img
            src="/logo.png"
            height={60}
            style={{ borderRadius: "10%" }}
          />

          <Typography sx={{ fontSize: 22, fontWeight: 600, color: "#222" }}>
            Matoshree Infra
          </Typography>
        </Box>

        {/* Right Menu */}
        <Box display="flex" alignItems="center" gap={4}>
          <Typography sx={{ cursor: "pointer", color: "#666", fontSize: 15 }}>
            Already have an account?
          </Typography>

          <Button
            variant="contained"
            size="small"
            href="/login"
            sx={{
              backgroundColor: "#4c6fff",
              borderRadius: "20px",
              px: 3,
              "&:hover": { backgroundColor: "#3c55d6" },
            }}
          >
            LOGIN
          </Button>

          <Typography sx={{ cursor: "pointer", fontSize: 15, color: "#333" }}>
            Help
          </Typography>
          <Typography sx={{ cursor: "pointer", fontSize: 15, color: "#333" }}>
            Support
          </Typography>
        </Box>
      </Box>

      {/* ========================= BODY ========================= */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
        px={2}
      >
        <Paper
          elevation={4}
          sx={{
            width: 440,
            p: 5,
            borderRadius: 4,
            background: "#ffffff",
            boxShadow: "0px 7px 20px rgba(0,0,0,0.05)",
          }}
        >
          <Typography
            variant="h5"
            mb={1}
            textAlign="center"
            fontWeight={600}
            color="#333"
          >
            Create your account
          </Typography>

          <Typography variant="body2" mb={3} textAlign="center" color="#777">
            Join Travel To Xplore and get started
          </Typography>

          {msg && (
            <Alert severity="info" sx={{ mb: 3, borderRadius: 2 }}>
              {msg}
            </Alert>
          )}

          {/* Name */}
          <TextField
            fullWidth
            size="small"
            label="Full Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            size="small"
            label="Propety Name"
            value={propName}
            onChange={(e) => setpropName(e.target.value)}
            sx={{ mb: 2 }}
          />

          {/* Email */}
          <TextField
            fullWidth
            size="small"
            label="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2 }}
          />

          {/* Password */}
          <TextField
            fullWidth
            size="small"
            type="password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ mb: 2 }}
          />

          {/* Confirm Password */}
          <TextField
            fullWidth
            size="small"
            type="password"
            label="Confirm Password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            sx={{ mb: 3 }}
          />

          {/* REGISTER BUTTON */}
          <Button
            fullWidth
            size="small"
            variant="contained"
            disabled={loading}
            onClick={handleRegister}
            sx={{
              py: 1.4,
              borderRadius: "12px",
              backgroundColor: "#323ec8",
              fontSize: 16,
              "&:hover": { backgroundColor: "#202ea8" },
            }}
          >
            {loading ? <CircularProgress size={26} /> : "Create Account"}
          </Button>

          <Typography
            textAlign="center"
            mt={3}
            color="#555"
            fontSize={14}
          >
            Already have an account?{" "}
            <a href="/login" style={{ color: "#323ec8", fontWeight: 600 }}>
              Login here
            </a>
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}
